import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { mergeMap } from 'rxjs/operators';
import { catchApiError, IClientApiDependencySegment } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { downloadFileFromResponse } from '@cbridge-utils/file';
import { RoutingRuleAction } from '../routingRule.action';

type IDependencies = IClientApiDependencySegment;

export const exportRoutingRulesEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(RoutingRuleAction.exportFile.started),
  mergeMap((params) => {
    return dependencies.api.exportRoutingRules().pipe(
      mergeMap((response) => {
        downloadFileFromResponse(response);
        return [];
      }),
      catchApiError((error) => {
        return [
          RoutingRuleAction.exportFile.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
